import React from 'react';
import FundingCopyableField from './FundingCopyableField';
import { revealApplicationPassword } from '../../../services/funding/fundingClientsService';

const SecureApplicationPasswordField = ({
  maskedValue = '••••••••',
  hasPassword = false,
  clientId,
  agencyId,
  className = '',
  testId = 'application-password-field',
}) => {
  if (!hasPassword) {
    return <span className="text-[var(--fg-muted)]">—</span>;
  }

  const reveal = async () => {
    if (!clientId || !agencyId) return null;
    return revealApplicationPassword(clientId, agencyId);
  };

  const copy = async ({ revealed, revealedValue }) => {
    if (revealed && revealedValue) return revealedValue;
    return reveal();
  };

  return (
    <FundingCopyableField
      inline
      maskedValue={maskedValue}
      isSensitive
      canReveal={hasPassword}
      onReveal={reveal}
      onCopy={copy}
      className={className}
      testId={testId}
    />
  );
};

export default SecureApplicationPasswordField;
